import React from 'react';
import cn from 'classnames';
import './SquareRadioButton.styl';
import classNames from 'classnames';

export interface SquareRadioButtonProps {
  icon?: any;
  text?: JSX.Element | string;
  value: any;
  onSelect: (checked: any) => void;
  selectedOption: any;
  textPosition?: 'right' | 'below';
  width?: number;
  vertical?: boolean;
}

export default class SquareRadioButton extends React.PureComponent<SquareRadioButtonProps> {
  getSelectedClassName() {
    const {value, selectedOption} = this.props;
    if (selectedOption === null) return '';

    return selectedOption === value ? 'selected' : 'not-selected';
  }

  render() {
    const {
      width,
      icon: Icon = defaultIcon,
      text,
      onSelect,
      value,
      textPosition = 'below',
      vertical = false,
    } = this.props;

    return (
      <div
        style={width ? {width} : {}}
        className={cn('square-radio-button', this.getSelectedClassName(), textPosition)}
        onClick={() => onSelect(value)}>
        <div className={classNames('content-wrapper', {vertical})}>
          <div className="icon-wrapper">
            <div>
              <Icon className="icon" />
            </div>
          </div>
          <div className={cn('text-wrapper', textPosition)}>{text}</div>
        </div>
      </div>
    );
  }
}

const defaultIcon = ({className}) => <div className={className} />;
